import { message } from 'antd';

message.config({
  top: 160,
});

export default message;
